import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Options, SliderComponent } from '@angular-slider/ngx-slider';
import { CssPropertyParserService } from '../../services/css-property-parser.service';
@Component({
  selector: 'kve-padding-input',
  templateUrl: './padding-input.component.html',
  styleUrls: ['./padding-input.component.scss']
})
export class PaddingInputComponent implements OnInit,OnChanges {
  @Input() paddingString:string;
  sliderControl: FormControl = new FormControl(0);
  options: Options = {
    floor: 0,
    ceil: 12
  };
  valueAll = 8;
  valueTop = 8;
  valueRight = 8;
  valueBottom = 8;
  valueLeft = 8;

  selectedUom;
  uoms = [
    {name:"px",value:"px"},
    {name:"rem",value:"rem"},
    {name:"em",value:"em"}
  ]

  @Output() paddingChange = new EventEmitter<string>();

   @ViewChild('valueSlider') valueSlider: SliderComponent;

  constructor(private cssPropertyParserService:CssPropertyParserService) { }
  

  ngOnInit(): void {
    
  }

  // UOM change handler
  changeUom(selectedUom: any): void {
    this.selectedUom = selectedUom;
    this.emitChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["paddingString"]){
      if(this.paddingString != undefined && this.paddingString != ""){
        const result = this.cssPropertyParserService.parseBorder(this.paddingString);
        this.valueAll = this.cssPropertyParserService.extractNumber(result.valueAll);
        if(this.valueAll && this.valueAll > 0){
          this.sliderControl.setValue(this.valueAll)
        }
        this.valueTop = this.cssPropertyParserService.extractNumber(result.valueTop);
        this.valueRight = this.cssPropertyParserService.extractNumber(result.valueRight);
        this.valueBottom = this.cssPropertyParserService.extractNumber(result.valueBottom);
        this.valueLeft = this.cssPropertyParserService.extractNumber(result.valueLeft);
        this.selectedUom = this.uoms.find(uom => uom.name === this.cssPropertyParserService.getUnitFromResult(result)) || this.uoms[0];

        console.log(this.selectedUom);
      }
      this.selectedUom = this.selectedUom ? this.selectedUom:"px";
      if(this.selectedUom.name == "rem"){
        this.options.ceil = 2;
        this.options.step = 0.1
      }
    }
  }

  // Emit changes to parent component
  private emitChanges(): void {
    const paddingString = this.generatePaddingString();
    this.paddingChange.emit(paddingString);
  }

  // CSS generation methods
  private generatePaddingString(): string {
    if (this.allValuesEqual()) {
      return `${this.valueAll}${this.selectedUom.value}`;
    }
    return `${this.valueTop}${this.selectedUom.value} ${this.valueRight}${this.selectedUom.value} ${this.valueBottom}${this.selectedUom.value} ${this.valueLeft}${this.selectedUom.value}`;
  }

  private allValuesEqual(): boolean {
    return this.valueTop === this.valueRight && 
           this.valueRight === this.valueBottom && 
           this.valueBottom === this.valueLeft;
  }

  sliderUserChangeEnd(e){
    this.valueAll = e.value;
    console.log("sliderUserChangeEnd",e.value);
    this.onValueAllChange();
  }

  onValueAllChange(): void {
    this.valueTop = this.valueRight = this.valueBottom = this.valueLeft = this.valueAll;
    console.log({top:this.valueTop,bottom:this.valueBottom})
    this.sliderControl.setValue(this.valueAll);
    this.emitChanges();
  }

  onIndividualValueChange(e): void {
    // Update valueAll if all individual values are the same
    if (this.allValuesEqual()) {
      this.valueAll = this.valueTop;
      this.sliderControl.setValue(this.valueAll);
    }
    this.emitChanges();
  }

  

}
